import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getFeesRequest: ['visaTypeId'],
  getFeesSuccess: ['fees'],
  getFeesFailure: ['error'],
  getQuoteRequest: ['fee', 'paymentMethodId'],
  getQuoteSuccess: ['quote'],
  getQuoteFailure: ['error'],
  getPaymentMethodsRequest: ['isLAO'],
  getPaymentMethodsSuccess: ['paymentMethods'],
  getPaymentMethodsFailure: ['error'],
  payRequest: null,
  paySuccess: ['paymentRecord'],
  payFailure: ['error'],
  submitPaymentRequest: ['uuid', 'status'],
  submitPaymentSuccess: ['paymentRecord'],
  submitPaymentFailure: ['error'],
  performCashPaymentFlow: [
    'quoteId',
    'file',
    'cashPaymentReceiptNum',
    'successPageUrl',
    'failPageUrl',
    'abortPageUrl',
  ],
  performMockPaymentFlow: ['quoteId', 'uuid', 'push'],
  sendPaymentLink: ['uuid'],
  sendPaymentLinkSuccess: null,
  sendPaymentLinkFailure: ['error'],
  markForLocalPayment: ['uuid', 'push'],
  markForLocalPaymentSuccess: ['application'],
  markForLocalPaymentFailure: ['error'],
  getPaymentInfoRequest: ['uuid'],
  getPaymentInfoSuccess: ['quote, history'],
  getPaymentInfoFailure: ['error'],
  clearPaymentLinkSent: null,
  submitZeroPayment: ['quote'],
  submitZeroPaymentSuccess: ['paymentRecord'],
  submitZeroPaymentFailure: ['error'],
});

export const PaymentTypes = Types;
export default Creators;



// WEBPACK FOOTER //
// ./src/state/actions/PaymentActions.js